// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import StandardLayout from '~/components/widgets/layouts/standard/layouts-standard.component';

import { ActionIcon, Container, IconContainer, SecondaryTextBody, TextBody } from './styles';
import messages from './intl';

const DiscoverSplash = () => (
    <StandardLayout>
        <Container>
            <IconContainer isModal={false}>
                <ActionIcon />
            </IconContainer>
            <FormattedMessage {...messages.body}>{msg => <TextBody>{msg}</TextBody>}</FormattedMessage>
            <FormattedMessage {...messages.description}>
                {msg => <SecondaryTextBody>{msg}</SecondaryTextBody>}
            </FormattedMessage>
        </Container>
    </StandardLayout>
);

export default DiscoverSplash;



// WEBPACK FOOTER //
// ./src/components/widgets/actions/entry/my-actions/discover-splash/index.js